module.exports = __webpack_public_path__ + "down-arrow_07.png?c0407aa793f45ab6c18f79e15937c603";


//////////////////
// WEBPACK FOOTER
// ./static/assets/down-arrow_07.png
// module id = 26
// module chunks = 0